import { FunctionComponent } from 'react'
import { colors, Tooltip } from '@black-bear-energy/rucksack'
import {
  CheckCircleRounded,
  ErrorOutlineRounded,
  PendingActionsRounded,
} from '@mui/icons-material'
import { DocumentRequirement } from '@black-bear-energy/black-bear-energy-common'
import { rucksack } from '@black-bear-energy/rucksack'

const tooltipSlotProps = {
  popper: {
    modifiers: [{ name: 'offset', options: { offset: [0, -14] } }],
  },
}

export const ReviewStatusIcon: FunctionComponent<ReviewStatusIconProps> = ({
  document,
}) => {
  if (!document.uploaded) {
    return null
  }

  if (document.review === null || document.review.outdated) {
    return (
      <Tooltip
        title="Pending Review"
        placement="bottom"
        slotProps={tooltipSlotProps}
      >
        <PendingActionsRounded
          sx={{ color: colors.ore[500], height: '20px', width: '20px' }}
        />
      </Tooltip>
    )
  }

  if (document.review.verified === false) {
    return (
      <Tooltip title="Rejected" placement="bottom" slotProps={tooltipSlotProps}>
        <ErrorOutlineRounded
          sx={{
            color: rucksack.palette.error.main,
            height: '20px',
            width: '20px',
          }}
        />
      </Tooltip>
    )
  }

  return (
    <Tooltip title="Approved" placement="bottom" slotProps={tooltipSlotProps}>
      <CheckCircleRounded
        sx={{
          color: rucksack.palette.success.main,
          height: '20px',
          width: '20px',
        }}
      />
    </Tooltip>
  )
}

interface ReviewStatusIconProps {
  document: DocumentRequirement
}
